var _ellipse, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.5547,
    cy: 24.5098,
    rx: 25,
    ry: 24.5098,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3195_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5547 25C41.5547 16.7157 34.839 10 26.5547 10C18.2704 10 11.5547 16.7157 11.5547 25C11.5547 32.4869 17.04 38.6925 24.2109 39.8178V29.3359H20.4023V25H24.2109V21.6953C24.2109 17.9359 26.4503 15.8594 29.8767 15.8594C31.5178 15.8594 33.2344 16.1523 33.2344 16.1523V19.8438H31.3429C29.4796 19.8438 28.8984 21 28.8984 22.1862V25H33.0586L32.3936 29.3359H28.8984V39.8178C36.0694 38.6925 41.5547 32.4869 41.5547 25Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3936 29.3359L33.0586 25H28.8984V22.1862C28.8984 21 29.4795 19.8438 31.3429 19.8438H33.2344V16.1523C33.2344 16.1523 31.5178 15.8594 29.8767 15.8594C26.4503 15.8594 24.2109 17.9359 24.2109 21.6953V25H20.4023V29.3359H24.2109V39.8178C24.9746 39.9376 25.7573 40 26.5547 40C27.352 40 28.1347 39.9376 28.8984 39.8178V29.3359H32.3936Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3195_54"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(11.5547 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.8ba01f87fb6003b8219ce4de1f9f3a01.svg";
export { ForwardRef as ReactComponent };